import { render, staticRenderFns } from "./TCEdetail.vue?vue&type=template&id=beaf9172&scoped=true"
import script from "./TCEdetail.vue?vue&type=script&lang=js"
export * from "./TCEdetail.vue?vue&type=script&lang=js"
import style0 from "./TCEdetail.vue?vue&type=style&index=0&id=beaf9172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf9172",
  null
  
)

export default component.exports